import React from "react";
import
{
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Row,
    Col
} from "reactstrap";
import LoadingComponent from '../../../../components/loading/LoadingComponent'
import {QRCodeSVG} from 'qrcode.react';

var translator = require('../../../../utils/translator/translator');
var rmsApiProxyRetry = require('../../../../utils/api/rmsApiProxyRetry');
var stringUtil = require('../../../../utils/string/stringUtil');
var constants = require('../../../../utils/domain/constants');
var viewUtil = require('../../../../utils/view/viewUtil');
var saleContextUtil = require('../../utils/saleContextUtil');
var logger = require('../../../../utils/logger/logger');


class VoucherCodeApplierDialogue extends React.Component
{
    constructor(props)
    {
        super(props);
        this.applyVoucher = this.applyVoucher.bind(this);

        this.state = {};
        this.state.unMounted = false;
    }

    render()
    {
        this.applyVoucher();

        return <Modal isOpen={true} centered backdrop={true} animation={false} fade={false}>
                    <ModalBody>
                        <div className="w-100 d-flex flex-column justify-content-center align-content-center">
                            <div style={{textAlign:'center', marginTop:'20px', marginBottom:'20px'}}>
                                <QRCodeSVG value={this.props.qrCode} fgColor="var(--colors-primary)" size="5vw"/>
                            </div>
                            <div style={{textAlign:'center'}}>
                                <LoadingComponent waitMessage={translator.getLabel("please_wait_applying_voucher")}/>
                            </div>
                            <div style={{textAlign:'center', marginTop:'20px', marginBottom:'5px'}}>
                                <Button className='btn-cancel' block
                                        onClick={()=>
                                            {
                                                this.state.unMounted = true;
                                                this.props.onFinish();
                                            }}>{translator.getLabel("cancel")}
                                </Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
    }

    async applyVoucher()
    {
        try
        {
            let saleContext = saleContextUtil.getCurrentSaleContext();
            let sale = saleContext.sale;
    
            var customerResource = `${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/sales/calculators/voucherDiscount/${stringUtil.trimString(this.props.qrCode)}`;
            let voucherResult = await rmsApiProxyRetry.put(customerResource, sale);
    
            if (this.state.unMounted)
                return;
    
            if (voucherResult == null)
            {
                logger.error(`Null result returned by server when applying for voucher.`);
                this.props.onFinish();
                viewUtil.showErrorAlert(`Failed to apply voucher`);
                return;
            }
    
            if (!stringUtil.isStringNullOrEmpty(voucherResult.rejectionReason))
            {
                this.props.onFinish();
                viewUtil.showErrorAlert(voucherResult.rejectionReason);
                return;
            }
    
            if (!stringUtil.isStringNullOrEmpty(voucherResult.rejectionCode))
            {
                this.props.onFinish();
                viewUtil.showErrorAlert(voucherResult.rejectionCode);
                return;
            }
    
            sale.discounts = [];        //Remove all existing discounts
                                
            var discount = {};
            discount.type = voucherResult.voucherCode;
            discount.amount = voucherResult.discountAmount;
            discount.discountOfferType = constants.DiscountOfferTypes.Voucher;
            sale.discounts.push(discount);
            this.props.onFinish();
    
            saleContextUtil.raiseSaleContextSaleChangeEvent(false);
            viewUtil.showSuccessAlert(`Voucher has been applied successfully`);
        }
        catch(error)
        {
            logger.error(`Error ocurred while applying error: ${error}`);
            this.props.onFinish();
            viewUtil.showErrorAlert(`Failed to apply voucher`);
        }
        
    }
}

export default VoucherCodeApplierDialogue;